import d from "./node_modules/lottie-react/build/index.es.js";export default d;
export * from "./node_modules/lottie-react/build/index.es.js"